/* eslint-disable */
export default {
  matched: 'Vastaava(t)',
  other: 'Muu',
  associated: 'Liittyvä(t)',
  foundFromServer: 'Löydetty sovelluksesta {appName}',
  recently: 'Viimeaikaiset',
  additionalLabelAccount: 'Tili: {displayName}',
  additionalLabelContact: 'Yhteystieto: {displayName}',
  notFound: '–',
} as const;

// @key: @#@"matched"@#@ @source: @#@"Matched"@#@
// @key: @#@"other"@#@ @source: @#@"Other"@#@
// @key: @#@"associated"@#@ @source: @#@"Associated"@#@
// @key: @#@"foundFromServer"@#@ @source: @#@"Found from {appName}"@#@
// @key: @#@"recently"@#@ @source: @#@"Recent"@#@
// @key: @#@"additionalLabelAccount"@#@ @source: @#@"Account: {displayName}"@#@
// @key: @#@"additionalLabelContact"@#@ @source: @#@"Contact: {displayName}"@#@
// @key: @#@"notFound"@#@ @source: @#@"N/A"@#@
